import { Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { lightGrey } from 'utils/colors';
import {
    heightPercentageToDP,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    root: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 16,
    },
    inPutView: {
        // @ts-ignore
        cursor: 'text',
        flexDirection: 'row',
        height: 55,
        width: widthPercentageToDP(328),
        alignSelf: 'center',
        borderColor: '#EEEEEE80',
        borderRadius: 4,
        borderWidth: 1,
    },
    inputError: {
        width: widthPercentageToDP(296),
        fontFamily: Fonts.main.regular,
        marginTop: 8,
        color: 'red',
    },
    inPutPlaceholderTop: {
        fontFamily: Fonts.main.regular,
        color: lightGrey(0.7),
        fontSize: 16,
        width: widthPercentageToDP(296),
        top: heightPercentageToDP(0),
        left: widthPercentageToDP(16),
        zIndex: 1,
        alignSelf: 'center',
    },
    inPutPlaceholderTopFocused: {
        fontFamily: Fonts.main.regular,
        color: lightGrey(0.7),
        fontSize: 12,
        width: widthPercentageToDP(296),
        marginTop: heightPercentageToDP(5),
        left: widthPercentageToDP(16),
        zIndex: 1,
        alignSelf: 'flex-start',
    },
    inPutPlaceholder: {
        height: 24,
        width: widthPercentageToDP(260),
        left: widthPercentageToDP(16),
        marginTop: Platform.select({
            web: 22,
            default: heightPercentageToDP(15),
        }),
        position: 'absolute',
        fontFamily: Fonts.main.regular,
        color: lightGrey(),
        fontSize: 14,
        zIndex: 2,
        padding: 0,
    },
    eye: {
        cursor: 'pointer',
        zIndex: 9,
        height: 55,
        width:
            widthPercentageToDP(328) -
            widthPercentageToDP(260) -
            widthPercentageToDP(16),
        justifyContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        right: 0,
    },
});

export default styles;
